var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 546.527,
    height: 193.34,
    viewBox: "0 0 546.527 193.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(0.491 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M-10.757,22.672a2.237,2.237,0,0,1-2.236,2.237,2.237,2.237,0,0,1-2.236-2.237,2.237,2.237,0,0,1,2.236-2.236,2.237,2.237,0,0,1,2.236,2.236Z",
    transform: "translate(27.024 13.811)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M48.1,37.982a1.9,1.9,0,1,1-1.9-1.9,1.9,1.9,0,0,1,1.9,1.9Z",
    transform: "translate(8.862 9.038)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M184.065,81.4a3.477,3.477,0,1,1-3.477-3.477,3.477,3.477,0,0,1,3.477,3.477Z",
    transform: "translate(-31.649 -3.726)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M265.576,89.413a2.845,2.845,0,1,1-2.845-2.845,2.845,2.845,0,0,1,2.845,2.845Z",
    transform: "translate(-56.899 -6.362)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M280.406,29.517a2.528,2.528,0,1,1-2.528-2.528,2.528,2.528,0,0,1,2.528,2.528Z",
    transform: "translate(-61.616 11.812)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M155.423,141.331a2.687,2.687,0,1,1-2.687-2.687A2.687,2.687,0,0,1,155.423,141.331Z",
    transform: "translate(-23.394 -22.248)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M45.372,114.425a1.9,1.9,0,1,1-1.9-1.9A1.9,1.9,0,0,1,45.372,114.425Z",
    transform: "translate(9.695 -14.281)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M308.547.8l1.062,2.153,2.376.345-1.719,1.676.406,2.366-2.125-1.117L306.422,7.34l.406-2.366L305.109,3.3l2.376-.345Z",
    transform: "translate(-70.694 19.801)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M-11.3,62.333l1.767,3.581,3.951.574-2.859,2.787.675,3.935L-11.3,71.353l-3.534,1.858.675-3.935-2.859-2.787,3.951-.574Z",
    transform: "translate(27.571 1.031)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M45.676,178.324l.958,1.941,2.142.311-1.55,1.511.366,2.134-1.916-1.007-1.916,1.007.366-2.134-1.55-1.511,2.142-.311Z",
    transform: "translate(9.391 -34.352)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M1.219,215.1l1.175,2.381,2.627.382-1.9,1.853.449,2.617L1.219,221.1l-2.35,1.235.449-2.617-1.9-1.853,2.627-.382Z",
    transform: "translate(23.166 -45.572)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M204.469,94.424c1.418.19,2.33,1.282,3.457,2.049,1.211.825,2.749,1.3,3.845,2.265a7.758,7.758,0,0,1-.1-1.15l-.3-2.77c-.1-.923-.213-1.846-.328-2.768-.026-.218-.009-1.012-.158-1.144-1.094-.965-2.634-1.45-3.845-2.265-1.135-.762-2.034-1.858-3.457-2.049.1.013.372,3.61.408,3.92C204.02,90.842,204.243,94.394,204.469,94.424Z",
    transform: "translate(-39.721 -6.369)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M261.525,48.9c-1.668.043-3.181,1.138-4.82,1.491a34.394,34.394,0,0,1-5.138.833c.2-.012.91,7.8,1.232,7.786a34.366,34.366,0,0,0,5.138-.833c1.639-.352,3.152-1.447,4.819-1.491C262.472,56.689,261.928,48.886,261.525,48.9Z",
    transform: "translate(-54.361 5.13)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M9.771-6.074c1.618.407,3.1,2.716,4.074,3.977,1.191,1.545,1.648,3.484,2.9,4.985A26.666,26.666,0,0,1,18.484-.648c.177-.368,1.91-3.284,1.673-3.569-1.247-1.5-1.709-3.438-2.9-4.985-.963-1.253-2.466-3.571-4.073-3.977C12.622-13.321,10.224-5.96,9.771-6.074Z",
    transform: "translate(19.398 24.066)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M-32.2,175.33c1.819,2.134,5.389,4.523,8.1,2.676,2.907-1.982,5.214-4.664,7.752-7.032.372-.347-.515.381-.322.235-.621.47-1.211,1.013-1.8,1.516-1.229,1.045-2.489,2.069-3.669,3.17-.673.628-1.2,1.375-1.857,2.012l5.894-5.02c-2.685,1.881-6.3-.564-8.1-2.676C-26.243,170.168-32.242,175.282-32.2,175.33Z",
    transform: "translate(32.201 -31.877)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M251.217-5.584c1.074,1.821,2.28,3.576,3.3,5.43.586,1.069,1.8,2.338,2.015,3.53-.06-.327,2.562-2.392,2.878-2.693.671-.641,1.343-1.284,2.008-1.933.118-.115.839-.688.816-.817-.216-1.192-1.43-2.462-2.015-3.53-1.015-1.854-2.221-3.61-3.3-5.431.044.075-2.654,2.48-2.878,2.694S251.107-5.769,251.217-5.584Z",
    transform: "translate(-54.253 23.409)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M108.59,141.366a7.153,7.153,0,0,0,3,2.082,37.648,37.648,0,0,1,3.972,2.018,28.155,28.155,0,0,0,2.6-2.961c.2-.236,2.427-3.072,2.541-3.013a37.779,37.779,0,0,0-3.971-2.019,7.12,7.12,0,0,1-3-2.082C113.864,135.526,108.379,141.146,108.59,141.366Z",
    transform: "translate(-10.745 -21.255)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M57.826,240.176a5.576,5.576,0,0,1,3.049,1.494c.969.723,2.164,1.024,3.1,1.786-.044-.035,1.8-3.165,1.942-3.43a29.348,29.348,0,0,0,1.874-3.468c-.938-.763-2.131-1.063-3.1-1.786a5.569,5.569,0,0,0-3.049-1.494c-.326-.017-1.747,3.075-1.943,3.43q-.673,1.22-1.338,2.444a9.3,9.3,0,0,1-.535,1.024Z",
    transform: "translate(4.739 -51.116)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M1.058,41.58c1.127.137,2.145,1.508,2.756,2.366.421.591.693,1.277,1.145,1.847.666.839,1.538,1.543,2.25,2.348a6.383,6.383,0,0,1-.118-1.149c-.107-.923-.222-1.844-.339-2.766s-.236-1.844-.363-2.764c-.035-.254-.011-.959-.172-1.142-.671-.759-1.44-1.428-2.105-2.188a23.4,23.4,0,0,1-1.29-2.006C2.216,35.273,1.184,33.9.066,33.76c.1.012.418,3.6.457,3.915S.832,41.553,1.058,41.58Z",
    transform: "translate(22.358 9.747)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 5.531,
    cy: 5.531,
    r: 5.531,
    transform: "translate(257.992 81.084)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M511.547,84.952a2.687,2.687,0,1,0,2.687-2.687,2.687,2.687,0,0,0-2.687,2.687Z",
    transform: "translate(-133.667 -5.049)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M435.28,35.88l.958-1.941,2.142-.311-1.55-1.511.366-2.134L435.28,30.99l-1.916-1.007.366,2.134-1.55,1.511,2.142.311Z",
    transform: "translate(-109.456 10.899)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M390.823-1.488,392-3.869l2.627-.382-1.9-1.853.449-2.617-2.35,1.235-2.35-1.235.449,2.617-1.9,1.853,2.627.382Z",
    transform: "translate(-95.681 22.705)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M452.587,69.569a17.433,17.433,0,0,0-7.757-3.8,17.156,17.156,0,0,0-7.178.484c-.339.076-2.311-2.658-2.583-2.978s-2.206-3.1-2.523-3.029a17.107,17.107,0,0,1,7.178-.484,17.465,17.465,0,0,1,7.757,3.8C449.54,65.111,450.549,68.038,452.587,69.569Z",
    transform: "translate(-109.568 1.877)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M639.252,208.431l-.914-1.853-2.045-.3,1.48-1.442-.349-2.036,1.829.961,1.829-.961-.349,2.036,1.48,1.442-2.045.3Z",
    transform: "translate(-171.72 -41.819)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M554.886,104.371c1.668-.043,3.181-1.138,4.819-1.491a34.318,34.318,0,0,1,5.138-.833c-.2.012-.91-7.8-1.232-7.786a34.378,34.378,0,0,0-5.138.833c-1.639.353-3.152,1.448-4.82,1.491C553.94,96.578,554.484,104.382,554.886,104.371Z",
    transform: "translate(-146.511 -8.709)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M578.945,30.478a21.044,21.044,0,0,0-2.137-1.914,9.521,9.521,0,0,1-1.846-1.405c.025.031-2.468,2.68-2.668,2.9a32.857,32.857,0,0,0-2.609,2.955,9.517,9.517,0,0,0,1.846,1.405,21.211,21.211,0,0,1,2.136,1.913C573.625,36.291,579.072,30.6,578.945,30.478Z",
    transform: "translate(-151.401 11.761)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M532.889-.251c-1.382-1.182-2.974-2.129-3.928-3.728a7.942,7.942,0,0,0-3.042-3.243c.25.122.167,3.537.19,3.937.054.927.11,1.855.174,2.781a4.4,4.4,0,0,0,.094,1.152,7.976,7.976,0,0,1,3.042,3.243c.965,1.6,2.541,2.542,3.929,3.728a8.8,8.8,0,0,1-.04-1.154c-.044-.928-.1-1.856-.15-2.783s-.11-1.856-.174-2.782C532.971.7,533.025-.135,532.889-.251Z",
    transform: "translate(-138.051 22.248)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M487.1-7.551a3.476,3.476,0,0,0-3.476-3.477,3.477,3.477,0,0,0-3.477,3.477,3.477,3.477,0,0,0,3.477,3.477A3.476,3.476,0,0,0,487.1-7.551Z",
    transform: "translate(-124.089 23.409)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M578.011-5.447c1.418-.19,2.33-1.281,3.457-2.049,1.21-.825,2.749-1.3,3.845-2.265a7.748,7.748,0,0,0-.1,1.15q-.15,1.386-.3,2.77c-.1.923-.212,1.846-.327,2.768-.027.218-.009,1.012-.158,1.144-1.093.965-2.633,1.45-3.845,2.265-1.134.763-2.034,1.858-3.457,2.049.1-.013.372-3.609.408-3.92C577.562-1.864,577.785-5.416,578.011-5.447Z",
    transform: "translate(-153.669 23.023)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M742.056,137.2l-1.767-3.581-3.951-.574,2.859-2.787-.675-3.935,3.534,1.858,3.534-1.858-.675,3.935,2.859,2.787-3.951.574Z",
    transform: "translate(-202.238 -18.489)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    transform: "translate(82.469 56.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M114.112,92.719a2.5,2.5,0,0,1-1.237-.836,3.3,3.3,0,0,1-.643-1.23,4.179,4.179,0,0,1-.111-.552c1.308.23,2.621-.624,3.971-.787a5.142,5.142,0,0,1,4.425,2.074,6.436,6.436,0,0,1,.467.646,8.142,8.142,0,0,1,.45.812,4.542,4.542,0,0,0-3.106-.856C116.895,92.162,115.5,93.117,114.112,92.719Z",
    transform: "translate(-94.293 -63.736)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M126.907,95.633a6.637,6.637,0,0,0-.51-.7h0l-2.2-2.624a6.44,6.44,0,0,1,.467.646,8.14,8.14,0,0,1,.45.812,18.7,18.7,0,0,1,1.361,4.774l2.237,2.676a15.78,15.78,0,0,0-1.808-5.584Z",
    transform: "translate(-97.979 -64.659)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M96.1,65.463c-1.673.8-3.87.919-5.22-.352a3.624,3.624,0,0,1-.266-.282L90.59,64.8a3.782,3.782,0,0,1-.755-1.648,5.459,5.459,0,0,0,4.028-.365,31.325,31.325,0,0,0,4.52-3.227c1.5-1.083,3.363-1.939,5.173-1.535a4.437,4.437,0,0,1,2.433,1.546,5.926,5.926,0,0,1,.941,1.573,4,4,0,0,0-1.137-.443c-1.811-.4-3.668.451-5.175,1.536A31.335,31.335,0,0,1,96.1,65.463Z",
    transform: "translate(-87.494 -54.169)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M88.806,61.5a5.247,5.247,0,0,1,.046-2.266,13.077,13.077,0,0,1,2.036-4.04l-2.237-2.676a13.057,13.057,0,0,0-2.036,4.038,4.59,4.59,0,0,0,.733,3.945l2.213,2.648A3.782,3.782,0,0,1,88.806,61.5Z",
    transform: "translate(-86.468 -52.522)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M111.875,83.04h0a3.3,3.3,0,0,1-.643-1.23,4.176,4.176,0,0,1-.11-.552h0a6.448,6.448,0,0,1,.183-2.336,33.049,33.049,0,0,1,2.576-6.144,12.689,12.689,0,0,0,1.528-6.417,6.262,6.262,0,0,0-1.386-3.391l-2.235-2.676h0a5.926,5.926,0,0,1,.941,1.573,6.384,6.384,0,0,1,.448,1.815,12.723,12.723,0,0,1-1.53,6.419,33.049,33.049,0,0,0-2.576,6.144A5.815,5.815,0,0,0,109,79.132a3.341,3.341,0,0,0,.642,1.231l.045.054a2.981,2.981,0,0,0,.256.257,2.983,2.983,0,0,1-.256-.257Z",
    transform: "translate(-93.293 -54.892)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395",
    transform: "translate(115.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M151.815,19.525c-.4,4.353-3.677,8.454-7.145,8.654-2.277.133-4.249-1.96-5.34-3.363l.3-2.807c1.092,1.4,3.064,3.494,5.341,3.361,2.848-.163,5.652-3.773,6.822-7.815a9.2,9.2,0,0,1,.022,1.97Z",
    transform: "translate(-135.28 14.69)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M145.38-11.216c-.147,1.7-2.229,3.136-3.7,4.742a2.8,2.8,0,0,1-.909-1.735,2.847,2.847,0,0,1,0-.625c.19-1.783,2.055-3.213,3.487-4.658a2.875,2.875,0,0,1,1.093,1.639A2.3,2.3,0,0,1,145.38-11.216Z",
    transform: "translate(-135.712 24.161)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M152.492,7.629V7.617A9.459,9.459,0,0,0,151.81,2.6c-2.074-4.4-8.058-4.818-10.369-7.03a2.8,2.8,0,0,1-.909-1.735,2.849,2.849,0,0,1,0-.625L140-1.872l-.01.085a2.848,2.848,0,0,0,0,.625c.461,3.952,8.759,3.418,11.278,8.766a8.1,8.1,0,0,1,.715,2.525,9.2,9.2,0,0,1,.022,1.97h0Z",
    transform: "translate(-135.477 22.116)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M145.274-28.844l-.291,2.721a58.7,58.7,0,0,0-8.763,2.1c-1.325-.109-2.288-.306-2.3-.915a.687.687,0,0,1,0-.075C134.019-25.868,135.995-27.152,145.274-28.844Z",
    transform: "translate(-133.63 28.844)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M143.7-19.174h0a2.2,2.2,0,0,0-.031-.681c-.491-2.418-4.813-2.262-7.574-2.487-1.325-.109-2.288-.306-2.3-.915a.687.687,0,0,1,0-.075l-.288,2.7v.094c.027,1.54,5.985,1.969,8.538,4.042a2.875,2.875,0,0,1,1.093,1.639,2.3,2.3,0,0,1,.037.637Z",
    transform: "translate(-133.502 27.162)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396",
    transform: "translate(435.017 86.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M632.2,104.709l-.152,2.773a10.8,10.8,0,0,0-.783,2.55,11.211,11.211,0,0,1,.935-5.323Z",
    transform: "translate(-611.195 -104.709)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M634.332,120.01a2.961,2.961,0,0,1,.19,1.18,1.888,1.888,0,0,1-.487,1.221l-.013.013a16.8,16.8,0,0,0-1.17-1.811,11.443,11.443,0,0,1-1.655-8.244,11.25,11.25,0,0,0,1.808,5.47,11.529,11.529,0,0,1,1.327,2.171Z",
    transform: "translate(-611.128 -107.045)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M621.708,132.772l.019-.391C621.723,132.512,621.715,132.642,621.708,132.772Z",
    transform: "translate(-608.288 -113.15)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M621.7,132.944l-.012.193Z",
    transform: "translate(-608.282 -113.322)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M621.676,133.467v0Z",
    transform: "translate(-608.278 -113.458)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M621.662,133.5h0l-.032.575Z",
    transform: "translate(-608.264 -113.492)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M631.151,126.283l-.013.013c-.837.858-2.287.551-3.359.009s-2.187-1.291-3.377-1.1c-1.4.227-2.27,1.682-2.533,3.074a12.654,12.654,0,0,0-.172,1.639l-.013.229c0,.131-.013.261-.019.391l-.011.193-.006.117v.077l-.032.575h0l-.047.869a11.165,11.165,0,0,1,.154-1.317c.262-1.392,1.135-2.846,2.532-3.074,1.19-.193,2.3.552,3.377,1.1s2.538.853,3.37-.022a1.883,1.883,0,0,0,.489-1.221V127.8l.15-2.736a1.888,1.888,0,0,1-.49,1.219Z",
    transform: "translate(-608.244 -110.918)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M621.61,134.33l-.047.869v.045Z",
    transform: "translate(-608.243 -113.745)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M621.537,135.923l.017-.278Z",
    transform: "translate(-608.236 -114.146)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M621.527,136.045l-.022.428C621.512,136.331,621.519,136.188,621.527,136.045Z",
    transform: "translate(-608.226 -114.268)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M607.052,140.549l.045-.822c-.01.205-.018.411-.03.614C607.062,140.412,607.058,140.48,607.052,140.549Z",
    transform: "translate(-603.817 -115.391)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M617.15,134.076h0l-.049.914-.017.278c-.008.143-.015.286-.022.428l-.01.191a10.952,10.952,0,0,1-.241,1.959c-.332,1.377-1.38,2.76-2.8,2.777a3.678,3.678,0,0,1-2.184-.91,9.881,9.881,0,0,0-1.979-1.364,2.158,2.158,0,0,0-2.271.2,2.348,2.348,0,0,0-.641,1.614l.094-1.723c.012-.2.02-.409.03-.614l.006-.113a2.659,2.659,0,0,1,.664-1.938,2.159,2.159,0,0,1,2.272-.2,9.99,9.99,0,0,1,1.979,1.366,3.688,3.688,0,0,0,2.186.91c1.415-.016,2.463-1.4,2.794-2.776a9.6,9.6,0,0,0,.218-1.573Z",
    transform: "translate(-603.783 -113.492)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M605.632,140.818c.006-.069.01-.138.015-.208l-.094,1.723v.043c-.02.233-.028.473-.04.709l-.011.2c-.009.172-.021.343-.041.507A4.571,4.571,0,0,1,602.4,147.5l.152-2.773a4.572,4.572,0,0,0,3.061-3.711c.007-.063.014-.129.021-.194Z",
    transform: "translate(-602.397 -115.66)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M606.918,143.151l-.04.709C606.889,143.624,606.9,143.385,606.918,143.151Z",
    transform: "translate(-603.764 -116.436)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397",
    transform: "translate(272.015 0.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M371.265-12.613a2.51,2.51,0,0,1,.73,1.3,3.314,3.314,0,0,1,.022,1.388,4.2,4.2,0,0,1-.149.543c-1.065-.793-2.622-.62-3.9-1.08a5.143,5.143,0,0,1-3.023-3.84,6.6,6.6,0,0,1-.127-.787,8.129,8.129,0,0,1-.038-.928,4.541,4.541,0,0,0,2.391,2.159C368.529-13.365,370.2-13.592,371.265-12.613Z",
    transform: "translate(-360.911 24.287)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M363.671-22.115a6.473,6.473,0,0,0,.142.853h0l.782,3.33a6.6,6.6,0,0,1-.127-.787,8.129,8.129,0,0,1-.038-.928,18.7,18.7,0,0,1,.928-4.877l-.8-3.4A15.758,15.758,0,0,0,363.671-22.115Z",
    transform: "translate(-360.561 27.919)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M371.994,18.429c1.854.038,3.871.917,4.506,2.659a3.427,3.427,0,0,1,.11.371l.008.037a3.78,3.78,0,0,1-.065,1.812,5.451,5.451,0,0,0-3.763-1.483,31.3,31.3,0,0,0-5.487.853c-1.831.292-3.876.222-5.311-.951a4.435,4.435,0,0,1-1.48-2.475,5.936,5.936,0,0,1-.134-1.828,4.011,4.011,0,0,0,.817.907c1.437,1.175,3.48,1.244,5.314.952a31.228,31.228,0,0,1,5.485-.854Z",
    transform: "translate(-359.563 14.087)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M381.6,25.1a5.245,5.245,0,0,1-1.058,2,13.07,13.07,0,0,1-3.634,2.7l.8,3.4a13.045,13.045,0,0,0,3.633-2.694,4.591,4.591,0,0,0,1.117-3.854l-.788-3.359a3.779,3.779,0,0,1-.07,1.807Z",
    transform: "translate(-364.612 12.3)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M370.3-9.247h0a3.313,3.313,0,0,1,.022,1.388,4.158,4.158,0,0,1-.149.543h0a6.451,6.451,0,0,1-1.213,2A33.02,33.02,0,0,1,363.9-.977a12.689,12.689,0,0,0-4.25,5.047,6.263,6.263,0,0,0-.285,3.653l.8,3.395h0a5.937,5.937,0,0,1-.134-1.828,6.406,6.406,0,0,1,.414-1.822,12.722,12.722,0,0,1,4.25-5.047,33.048,33.048,0,0,0,5.061-4.333,5.808,5.808,0,0,0,1.362-2.548,3.327,3.327,0,0,0-.021-1.389l-.016-.068a2.82,2.82,0,0,0-.114-.345,2.82,2.82,0,0,1,.114.345Z",
    transform: "translate(-359.213 22.223)",
    fill: "#fff",
    stroke: "#45338c",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfety);
export default __webpack_public_path__ + "static/media/confety.c5cac85943f1c59d0f0eeb9a8cc54484.svg";
export { ForwardRef as ReactComponent };